const addLocalStorage = (itemName, item) => {
  return window.localStorage.setItem(itemName, item)
}

export default addLocalStorage
